import RemovableLabel from "components/Atoms/RemovableLabel";
import React from "react";

interface Props<T extends unknown> {
  value: T[];
  renderLabelContent: (value: T) => React.ReactNode
  getId: (value: T) => string | number;
  removeItem: (item: T) => void;
}

export const RemovableLabelList = <T extends unknown>(props: Props<T>) => {
  if (props.value.length === 0) {
    return <></>;
  }

  return <div className="removableLabel-list">
    {props.value.map(i => <RemovableLabel
      key={props.getId(i)}
      onClick={() => props.removeItem(i)}
    >
      {props.renderLabelContent(i)}
    </RemovableLabel>)}
  </div>;
}